import { money, thumb, SaveChip, Collage, AddToCartButton } from "./shared";

export default function SimpleBundleCard({ bundle }) {
  const images = bundle.items.map((item) => item.image_url);

  return (
    <article className="card flex flex-col overflow-hidden">
      <div className="p-3 pb-0">
        <Collage urls={images} size="h-56" />
      </div>

      <div className="flex flex-1 flex-col p-6">
        <div className="flex items-start justify-between gap-3">
          <h3 className="display text-2xl">{bundle.title}</h3>
          <SaveChip percent={bundle.discount_percentage} className="mt-1 shrink-0" />
        </div>
        <p className="mt-2 text-sm leading-relaxed text-ink-soft">{bundle.description}</p>

        <ul className="mt-4 space-y-2.5">
          {bundle.items.map((item) => (
            <li key={item.id} className="flex items-center gap-3 text-sm">
              <img src={thumb(item.image_url, 96)} alt="" loading="lazy" className="h-9 w-9 rounded-lg object-cover" />
              <span className="min-w-0 flex-1">
                <span className="block truncate font-medium">{item.title}</span>
                {item.variant_title && <span className="block truncate text-xs text-ink-soft">{item.variant_title}</span>}
              </span>
              <span className="text-ink-soft">{money(item.price)}</span>
            </li>
          ))}
        </ul>

        <div className="mt-5 flex items-baseline gap-2.5">
          <span className="font-display text-2xl font-bold">{money(bundle.price)}</span>
          {bundle.compare_at_price && (
            <span className="text-sm text-ink/40 line-through">{money(bundle.compare_at_price)}</span>
          )}
          <span className="ml-auto text-xs font-semibold text-ink-soft">Ships as one kit</span>
        </div>

        <div className="mt-4">
          <AddToCartButton />
        </div>
      </div>
    </article>
  );
}
